export default "__VITE_ASSET__CWU2DiSX__"